import { Link } from "react-router-dom";
import { ArrowRight, CalendarCheck } from "lucide-react";
import Reveal from "../components/Reveal";
import { BOOKING_URL } from "@/lib/constants";

export default function CtaBanner() {
  return (
    <section data-testid="cta-banner" className="relative overflow-hidden py-24 sm:py-28">
      <div
        className="absolute inset-0 opacity-70"
        style={{ background: "radial-gradient(60% 90% at 50% 110%, rgba(212,175,55,0.12), transparent)" }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
            Ready for a website that{" "}
            <span className="text-gold-gradient">actually represents your business?</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-slate-400">
            Let's build a website that helps you grow.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/start"
            data-testid="cta-banner-consultation-btn"
            className="group inline-flex items-center gap-2.5 rounded-full bg-gold px-8 py-4 text-sm font-bold text-ink shadow-lg shadow-gold/20 transition-colors duration-300 hover:bg-goldlight"
          >
            Start My Website
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
          </Link>
          <Link
            to="/work"
            data-testid="cta-banner-see-work-btn"
            className="inline-flex items-center gap-2.5 rounded-full border border-navyline px-8 py-4 text-sm font-semibold text-slate-200 transition-colors duration-300 hover:border-gold/60 hover:text-gold"
          >
            See Our Work
          </Link>
        </Reveal>
        <Reveal delay={0.25}>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-banner-book-directly-link"
            className="mt-7 inline-flex items-center gap-2 font-mono text-[11px] font-semibold tracking-[0.2em] text-slate-500 transition-colors duration-300 hover:text-gold"
          >
            <CalendarCheck className="h-3.5 w-3.5" />
            OR BOOK A CALL DIRECTLY
          </a>
        </Reveal>
      </div>
    </section>
  );
}
